// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fFD-","option":"styles_option__2cDqn","selected":"styles_selected__1_UD-"};